
const borderRadiusFromPixelMap = {
    "0px": "rounded-none",
    "2px": "rounded-xs",
    "4px": "rounded-sm",
    "6px": "rounded-md",
    "8px": "rounded-lg",
    "12px": "rounded-xl",
    "16px": "rounded-2xl",
    "24px": "rounded-3xl",
    "32px": "rounded-4xl",
};

const themeToBorderRadius = {
    "0": "rounded-none",
    "1": "rounded-sm",
    "2": "rounded-md",
    "3": "rounded-lg",
    "4": "rounded-xl",
    "5": "rounded-2xl",
    "6": "rounded-3xl",
};

export const borderRadiusToTailwindClasses = (
    theme: Record<string, string>,
    id?: string,
) => {
    const tailwindClasses = [];

    if (theme?.borderRadius) {
        if (
            typeof theme.borderRadius === "string" &&
            theme.borderRadius.includes("px")
        ) {
            tailwindClasses.push(
                borderRadiusFromPixelMap?.[theme.borderRadius],
            );
        } else {
            tailwindClasses.push(
                `${themeToBorderRadius?.[theme.borderRadius]}`,
            );
            
        }
    }

    return tailwindClasses.filter(Boolean);
};
